import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import './infobox.scss';
import { StyleInfobox } from './infobox.scss.js';

const Infobox = ({
  baseClass,
  closeButton,
  closeButtonClick,
  cssModifier,
  icon,
  text,
  title,
  variant,
  ...extraProps
}) => {
  const classBase = cx(baseClass, {
    [`${baseClass}--${cssModifier}`]: cssModifier,
  });

  return (
    <StyleInfobox className={classBase} data-cy="cc-infobox" variant={variant} {...extraProps}>
      {icon}
      <div className="infobox__wrap-text">
        {title && <div className="infobox__title">{title}</div>}
        <div className="infobox__text">{text}</div>
      </div>
      {closeButton && (
        <div
          className="infobox__close-button"
          data-cy="cc-infobox--button"
          label="Close"
          onClick={closeButtonClick}
          onKeyPress={closeButtonClick}
          role="button"
          tabIndex="0"
        />
      )}
    </StyleInfobox>
  );
};

Infobox.defaultProps = {
  baseClass: 'infobox',
  closeButton: true,
  icon: null,
};

Infobox.propTypes = {
  baseClass: PropTypes.string,
  closeButton: PropTypes.bool,
  closeButtonClick: PropTypes.func,
  cssModifier: PropTypes.string,
  icon: PropTypes.node,
  text: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.oneOf(['neutral', 'success', 'fail']),
};

export { Infobox };
export default Infobox;
